import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Component4cards from '../components/component4cards'
import Component3cards from '../components/component3cards'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './welding-monitor.css'

const WeldingMonitor = (props) => {
  return (
    <div className="welding-monitor-container">
      <Helmet>
        <title>Контроль качества ручной сварки | Arcobo Welding Monitor</title>
        <meta
          name="description"
          content="Система мониторинга сварки через облачный сервис для контроля качества в реальном времени. Анализ данных и снижение количества дефектов сварки."
        />
        <meta
          property="og:title"
          content="Контроль качества ручной сварки | Arcobo Welding Monitor"
        />
        <meta
          property="og:description"
          content="Система мониторинга сварки через облачный сервис для контроля качества в реальном времени. Анализ данных и снижение количества дефектов сварки."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Контроль качества ручной сварки | Arcobo Welding Monitor"
        />
        <meta
          name="twitter:description"
          content="Система мониторинга сварки через облачный сервис для контроля качества в реальном времени. Анализ данных и снижение количества дефектов сварки."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/welding-monitor"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/welding-monitor"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"WeldingMonitor","item":"https://arcobo.tech/welding-monitor"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name11"></HeaderMain>
      <hr className="welding-monitor-separator1"></hr>
      <Componenttextimage
        image1Src="/1_Solution/1_2_1_Welding_monitor/main-1500w.webp"
        image1Alt="Arcobo Welding Monitor"
        rootClassName="componenttextimageroot-class-name4"
        textComponent={
          <Fragment>
            <span className="welding-monitor-text100">
              <span className="H1_extrasmall">
                Цифровой контроль сварочного производства в режиме реального
                времени
              </span>
              <br className="welding-monitor-text102"></br>
              <span className="text_large">
                Получайте полную картину работы сварочного участка: загрузку
                оборудования и персонала, расход материалов, качество сварки и
                причины простоев - из любого места через веб-интерфейс.
              </span>
              <br className="text_large"></br>
              <br></br>
              <span className="H1_small">Какие данные контролируются?</span>
              <br className="H1_small"></br>
              <span className="welding-monitor-text108 text_large">✔</span>
              <span className="text_large">
                {' '}
                Производительность персонала и загрузка участка
              </span>
              <br className="text_large"></br>
              <span className="welding-monitor-text111 text_large">✔</span>
              <span className="text_large"> </span>
              <span className="text_large">Время сварки </span>
              <br className="text_large"></br>
              <span className="welding-monitor-text115 text_large">✔</span>
              <span className="text_large"> Простои оборудования</span>
              <br className="text_large"></br>
              <span className="welding-monitor-text118 text_large">✔</span>
              <span className="text_large">
                {' '}
                Расход проволоки и защитного газа
              </span>
              <br className="text_large"></br>
              <span className="welding-monitor-text121 text_large">✔</span>
              <span className="text_large"> Потребление энергии</span>
              <br className="text_large"></br>
              <span className="welding-monitor-text124 text_large">✔</span>
              <span className="text_large"> Параметры сварки и </span>
              <span className="text_large">история каждого шва</span>
              <br className="text_large"></br>
              <span className="welding-monitor-text128 text_large">✔</span>
              <span className="text_large"> Ошибки оборудования</span>
              <span className="text_large">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br className="text_large"></br>
              <span className="welding-monitor-text132 text_large">✔</span>
              <span className="text_large"> Количество изделий</span>
              <br className="text_large"></br>
            </span>
          </Fragment>
        }
        componentTitle="ARCOBO Welding Monitor"
      ></Componenttextimage>
      <hr className="welding-monitor-separator2"></hr>
      <Component3images
        image1Src="/1_Solution/1_2_2-Kolarc/kolarc_21-200h.webp"
        image1Alt="Сварочные источники Kolarc"
        image2Src="/1_Solution/1_2_2-Kolarc/kolarc_22-200h.webp"
        image2Alt="Сварочные источники Kolarc"
        image3Src="/1_Solution/1_2_2-Kolarc/kolarc_23-200h.webp"
        image3Alt="Сварочные источники Kolarc"
        rootClassName="component3imagesroot-class-name8"
      ></Component3images>
      <hr className="welding-monitor-separator3"></hr>
      <Component4cards
        showImage
        showImage1
        showImage2
        showImage3
        rootClassName="component4cardsroot-class-name"
      ></Component4cards>
      <hr className="welding-monitor-separator4"></hr>
      <Component3cards
        componentText="Полная прозрачность работы сварочного цеха в режиме онлайн"
        feature1Title="Контролируйте"
        feature2Title="Анализируйте"
        feature3Title="Получайте уведомления"
        rootClassName="component3cardsroot-class-name2"
        componentTitle="Основные преимущества"
        feature1Title2={
          <Fragment>
            <span className="welding-monitor-text135">feature1Title</span>
          </Fragment>
        }
        feature2Title2={
          <Fragment>
            <span className="welding-monitor-text136">Анализируйте</span>
          </Fragment>
        }
        feature3Title2={
          <Fragment>
            <span className="welding-monitor-text137">
              Получайте уведомления
            </span>
          </Fragment>
        }
        feature1ImageSrc="/1_Solution/1_2_1_Welding_monitor/control-1500w.webp"
        feature1ImageAlt="Контроль сварочных параметров"
        feature2ImageSrc="/1_Solution/1_2_1_Welding_monitor/analyze-500h.webp"
        feature2ImageAlt="Анализ сварочного производства"
        feature3ImageSrc="/1_Solution/1_2_1_Welding_monitor/get-500h.webp"
        feature3ImageAlt="Отчёты Welding Monitor"
        feature1Description={
          <Fragment>
            <span className="welding-monitor-text138">
              <span>• Работу каждого сварщика</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Производительность смен</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Использование оборудования</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Расход материалов</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Выполнение производственного задания</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Причины простоев</span>
            </span>
          </Fragment>
        }
        feature2Description1={
          <Fragment>
            <span className="welding-monitor-text155">
              <span>• Производительность по участкам</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Эффективность оборудования</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Статистику по заказам</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Качество сварки</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Отклонения параметров</span>
            </span>
          </Fragment>
        }
        feature3Description1={
          <Fragment>
            <span className="welding-monitor-text169">
              <span>• Telegram</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Email</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Push</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>API</span>
            </span>
          </Fragment>
        }
      ></Component3cards>
      <Component3images
        image1Src="/1_Solution/1_2_2-Kolarc/kolarc_31-200h.webp"
        image1Alt="Сварочный источник Kolarc"
        image2Src="/1_Solution/1_2_2-Kolarc/kolarc_32-200h.webp"
        image2Alt="Сварочный источник Kolarc"
        image3Src="/1_Solution/1_2_2-Kolarc/kolarc_33-200h.webp"
        image3Alt="Сварочный источник Kolarc"
        rootClassName="component3imagesroot-class-name9"
      ></Component3images>
      <hr className="welding-monitor-separator5"></hr>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="welding-monitor-text180">
              Arcobo Welding Monitor поддерживает все современные цифровые
              сварочные источники Kolarc с функцией подключения к облачной
              платформе. Подключение не требует изменения технологии сварки и
              позволяет получать данные о работе оборудования в режиме реального
              времени.
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="welding-monitor-text181">
              <span>
                Для предприятий Казахстана Arcobo развернула локальный сервер на
                территории Республики Казахстан. Это обеспечивает высокую
                скорость работы системы, независимость от зарубежных серверов и
                хранение производственных данных в соответствии с внутренними
                требованиями предприятия.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="welding-monitor-text184">
              <span>
                Стоимость подписки составляет €128 в год за один сварочный
                источник. В стоимость входит использование платформы, хранение
                данных, обновления программного обеспечения и техническая
                поддержка.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="welding-monitor-text187">
              <span>
                Arcobo Welding Monitor автоматически собирает и анализирует:
                ток, напряжение и скорость подачи проволоки; расход проволоки,
                газа и электроэнергии; время сварки и простои оборудования;
                загрузку сварщиков; количество выполненных сварных швов; ошибки
                оборудования и отклонения от заданных режимов; статистику по
                сменам, заказам и производственным участкам.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="welding-monitor-text190">
              <span>
                Да.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Система поддерживает интеграцию с ERP, MES, CRM и другими
                корпоративными информационными системами через API. Это
                позволяет автоматически передавать производственные данные,
                строить сквозную аналитику и использовать информацию о сварке в
                общей цифровой инфраструктуре предприятия.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="welding-monitor-text195">
              <span>
                Нет.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Сварочные источники продолжают работать в штатном режиме даже
                при временном отсутствии интернет-соединения. После
                восстановления связи накопленные данные автоматически
                синхронизируются с сервером Arcobo Welding Monitor, поэтому
                производственный процесс не прерывается.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="welding-monitor-text200">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="welding-monitor-text201">answer</span>
          </Fragment>
        }
        showDiv={false}
        showDiv1={false}
        showDiv2={false}
        showDiv3={false}
        showDiv4={false}
        showDiv5={false}
        showDiv6
        showDiv7
        question1="Какие сварочные источники поддерживает Arcobo Welding Monitor?"
        question2="Где хранятся данные сварочного производства?"
        question3="Сколько стоит использование Arcobo Welding Monitor?"
        question4="Какие параметры контролирует система?"
        question5="Можно ли интегрировать Arcobo Welding Monitor с ERP или MES предприятия?"
        question6="Нужен ли постоянный доступ к Интернету?"
        rootClassName="componentfaqroot-class-name4"
      ></Componentfaq>
      <hr className="welding-monitor-separator6"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name11"></FooterMain>
    </div>
  )
}

export default WeldingMonitor
